<template>
    <q-page padding>
        <div class="row gutter-sm">
            <div class="col-12 q-mb-md carousel-home" v-if="home_banners.length > 0 && showBanner">
                <q-carousel class="text-white shadow-3" :height="`${getHeight}px`" infinite autoplay>
                    <q-carousel-slide :img-src="banner.image_mobile" v-for="(banner, index) in home_banners" :key="index" class="cursor-pointer background-slide" @click.native="openBanner(banner)" />
                </q-carousel>
            </div>

            <div class="col-12 q-mb-md carousel-home" v-if="banners_trainings.length > 0 && home_banners.length === 0">
                <q-card class="bg-white">
                    <q-card-title class="text-center bg-primary text-white">
                        {{ $t('next_steps')}}
                    </q-card-title>
                    <q-card-separator/>
                    <q-card-main class="text-center relative-position">
                        <q-carousel class="text-white shadow-3" :height="`${getHeight}px`" infinite autoplay ref="carousel">
                            <q-carousel-slide v-for="(banner, index) in banners_trainings" :img-src="banner.image_desktop" :key="index" @click.native="goToTraining(banner)">
                                <div class="absolute-bottom custom-caption-mobile">
                                    <div class="q-title">{{ banner.title }}</div>
                                </div>
                            </q-carousel-slide>
                        </q-carousel>
                    </q-card-main>
                </q-card>
            </div>

            <div class="col-6" v-for="(button, index) in getHomeButtons" :key="index">
                <q-card style="min-height: 100px; border-radius: 6px;" class="bg-primary" @click.native="$router.push({ name: button.to })">
                    <div class="row q-pl-md q-pt-md">
                        <div class="col-12 q-mb-sm">
                            <q-icon :name="button.icon" size="2rem" color="white" />
                        </div>

                        <div class="col-12 q-title text-white">
                            {{ $t(button.text) }}
                        </div>
                    </div>
                </q-card>
            </div>
        </div>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "feed", "news", "authenticated"] },

    data() {
        return {
            banners_trainings: [],
            home_banners: []
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            reload_content: 'common/reload_content',
            id_user_client_selected: 'common/id_user_client_selected',
            clients: 'params/clients'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        showBanner() {
            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if(obj) {
                if(obj.show_banner_mobile) return true
                else return false
            }
            else return true
        },

        getHomeButtons() {
            let buttons = []

            let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
            if (obj) {
                if (obj.has_courses) {
                    buttons.push({
                        icon: 'far fa-book-reader',
                        to: 'courses',
                        text: obj.title_trainings == '' ? 'courses' : obj.title_trainings
                    })
                }

                if (obj.has_live_classes) {
                    buttons.push({
                        icon: 'fal fa-chalkboard-teacher',
                        to: 'live_classes',
                        text: obj.title_live_classes == '' ? 'live_classes' : obj.title_live_classes
                    })
                }

                if (obj.has_trails) {
                    buttons.push({
                        icon: 'far fa-bezier-curve',
                        to: 'trails',
                        text: obj.title_trails == '' ? 'trails' : obj.title_trails
                    })
                }

                if (obj.has_webcasts) {
                    buttons.push({
                        icon: 'far fa-broadcast-tower',
                        to: 'webcasts',
                        text: obj.title_webcasts == '' ? 'webcasts' : obj.title_webcasts
                    })
                }

                if (obj.has_podcasts) {
                    buttons.push({
                        icon: 'far fa-podcast',
                        to: 'podcasts',
                        text: obj.title_podcasts == '' ? 'podcasts' : obj.title_podcasts
                    })
                }

                if (obj.has_library) {
                    buttons.push({
                        icon: 'far fa-books',
                        to: 'library',
                        text: obj.title_library == '' ? 'library' : obj.title_library
                    })
                }

                if (obj.has_feed) {
                    buttons.push({
                        icon: 'far fa-comment-alt-smile',
                        to: 'feed',
                        text: obj.title_feed == '' ? 'feed' : obj.title_feed
                    })
                }

                if (obj.has_news) {
                    buttons.push({
                        icon: 'far fa-newspaper',
                        to: 'news',
                        text: obj.title_news == '' ? 'news' : obj.title_news
                    })
                }

                buttons.push({
                    icon: 'far fa-question-square',
                    to: 'faq',
                    text: obj.title_faq == '' ? 'faq' : obj.title_faq
                })

                if (obj.has_profile) {
                    buttons.push({
                        icon: 'far fa-user',
                        to: 'profile',
                        text: obj.title_profile == '' ? 'profile' : obj.title_profile
                    })
                }
            }

            return buttons
        },

        getHeight() {
            let height = (220 / 395) * this.$q.screen.width
            return parseInt(height)
        }
    },

    methods: {
        fetchAll() {
            this.$q.loading.show()

            this.$axios.get(`/etraining_home/home/`, this.getHeader)
            .then(response => {
                this.score = response.data.user_statistics.user_score ? response.data.user_statistics.user_score.toFixed(2) * 1 : ''
                this.badges = response.data.badges
                this.news = response.data.news
                this.news_loaded = true
                this.banners_trainings = response.data.group_training_banners
                this.home_banners = response.data.home_banners

                this.$q.loading.hide()
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        goToTraining(item) {
            let target = ''

            switch(item.slug) {
                case 'group_training': target = 'course'
                break
                case 'group_trail':
                case 'group_trails': target = 'trail'
                break
                case 'webcasts':
                case 'webcast':
                case 'webnar':
                case 'webinar': target = 'webcast'
            }

            this.$router.push({ name: target, params: { id: item.id } })
        },

        openBanner(item) {
            if (item.url) {
                if (this.$q.platform.is.cordova && this.$q.platform.is.ios) {
                    cordova.InAppBrowser.open(item.url, '_system', 'usewkwebview=yes,hidenavigationbuttons=yes,toolbar=no')
                }
                else {
                    window.open(item.url, '_blank')
                }
            }
        },
    },

    watch: {
        reload_content: function() {
            this.fetchAll()
        }
    },

    created() {
        this.fetchAll()
    }
}
</script>

<style>

</style>
